export const getUrlTags = (): string => {
    if (document.URL.split('?')[1] !== undefined) {
        return document.URL.split('?')[1];
    } else if (document.URL.split('#')[1] !== undefined) {
        return document.URL.split('#')[1]
    } else {
        return 'undefined';
    }
}
